export enum AccountContactStatusDesc {
  Active = 'Active',
  Inactive = 'Inactive',
}
